module.exports = __webpack_public_path__ + "img/auth_dingtalk.9602dd4a.svg";